import { GET_PRODUCT_GROUPS, ADD_CATEGORY, ADD_COMPANY, DELETE_CATEGORY, DELETE_COMPANY } from 'redux/actionTypes';

export default function categories(state = {}, action) {
    switch(action.type) {
        case GET_PRODUCT_GROUPS:
            return {
                ...state,
                ...action.payload
            };
        case ADD_CATEGORY:
            return {
                ...state,
                productCategories: [ action.payload, ...state.productCategories ]
            };
        case ADD_COMPANY:
            return {
                ...state,
                productCompanies: [ action.payload, ...state.productCompanies ]
            };
        case DELETE_CATEGORY:
            const categoryIndex = state.productCategories.findIndex(category => category.name === action.payload.name);
            return {
                ...state,
                productCategories: [
                    ...state.productCategories.slice(0, categoryIndex),
                    ...state.productCategories.slice(categoryIndex + 1)
                ]
            };
        case DELETE_COMPANY:
            const companyIndex = state.productCompanies.findIndex(company => company.name === action.payload.name);
            return {
                ...state,
                productCompanies: [
                    ...state.productCompanies.slice(0, companyIndex),
                    ...state.productCompanies.slice(companyIndex + 1)
                ]
            };
        default:
            return state;
    }
};